import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { CompanyService } from '../../Services/Custom/ServiceCompany';

@Component({
	selector: 'CompanySearch',
	templateUrl: 'CompanySearch.html',
	moduleId: module.id
})
export class CompanySearchComponent {

	constructor(
		private myCompanyService: CompanyService,
		private router: Router) { }

	@Input() placeholderText = 'Company Search...';
	@Output() companyChange = new EventEmitter();

	pickItem($event: any) {
		$event.preventDefault();
		this.searchString = '';
		this.companyChange.emit($event.item);
	}

	searchString: string = '';
	searching: boolean = false;
	search = (text$: Observable<string>) => {
		return text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			tap(() => this.searching = true),
			switchMap((term: string) => this.myCompanyService.search(term)),
			tap(() => this.searching = false)
		)
	}
}
